import React from "react" 

import {Navbar2} from "./components/Navbar" 

import dataInfo from "./data.js"

import Footer from "./Footer.js"


export default function ProjMastersThesis() 
{
    let projInfo = dataInfo[0];

    for (let i=0; i<dataInfo.length; i++)
    {
        if(dataInfo.at(i).id == 1)
        {
            projInfo = dataInfo.at(i);
            break;
        }
    }

    // console.log("projInfo: ", projInfo)

    const bullets = projInfo.bullets.split(";").map(bullet => bullet.trim());

    const BulletElement = bullets.map((bullet, index) => 
                        {
                            return( 
                            <li key={index} >  {bullet}  </li> 
                             );
                        } );


    return ( 
        <div>
            <Navbar2/>

            <div class="aboutContainer">

                <div class="aboutLeft">


                {/* <iframe src="https://drive.google.com/file/d/12I6aDUUqfmnK_MajrFKdzKS_07pwDHkz/preview" width="640" height="480" allow="autoplay"></iframe> */}

                {/* <iframe src="https://drive.google.com/file/d/1ouiu0E4XPyQ9FeUc4uhuexMUAXQNdXAU/preview" width="640" height="480"></iframe> */}

                <iframe src="https://drive.google.com/file/d/1ouiu0E4XPyQ9FeUc4uhuexMUAXQNdXAU/preview"
                  width="640" height="480" allow="autoplay" speed></iframe>

                </div>

                <div class="aboutRight">

                        <h1 >
                            {projInfo.title}
                        </h1>

                        <p>
                        {projInfo.description.split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                    <br />
                                </React.Fragment>
                            ))}

                            {/* {projInfo.description} */}
                        </p>

                        <ul>
                            {BulletElement}
                        </ul>

                        {
                            projInfo.downloadLink!="" ? 
                            <a className="skillTab" href={projInfo.downloadLink}  download={projInfo.downloadName} >
                            Download the application
                            </a> : null
                        }

                        {
                            projInfo.liveDemoLink!="" ? 
                            <a className="skillTab" href={projInfo.liveDemoLink} target="_blank" rel="noopener noreferrer" >
                            Link to thesis
                            </a> : null
                        }

                        {
                            projInfo.githubLink!="" ? 
                            <a className="skillTab" href={projInfo.githubLink}  >
                            Github link
                            </a> : null
                        }
                        

                </div>
             </div>

             <div class="additionalData">


                        <p>
                            Quick Note: The acknowledgements page didn't make it into the final draft of the thesis, as deadlines wait for no one. 
                            So here is an informal version of the same, because better late than never.
                        </p>

                        <h1>
                            Acknowledgement 
                        </h1>

                        <p>

                            This thesis would not have been possible without the guidance and unwavering support of many people, and I am deeply grateful to all of them.

                            <br /> <br /> 

                            First and foremost, I would like to express my sincere gratitude to my supervisors, 
                            <a href="https://www.linkedin.com/in/dr-mohamed-m-atia/" target="_blank">  Prof. Dr. Mohamed Atia </a> and 
                            <a href="https://www.linkedin.com/in/sreeraman-rajan-82586525/" target="_blank">  Prof. Dr. Sreeraman Rajan</a>. 
                            Their mentorship throughout this journey was invaluable- from shaping the research direction to providing the resources and encouragement 
                            needed to see it through. I am deeply thankful for the time and expertise they invested in this work.

                            I am also profoundly grateful to my parents and family, whose encouragement has been a constant source of strength.
                            A heartfelt thanks to                             
                            <a href="https://www.linkedin.com/in/mansi-luthra-0616a1163/" target="_blank"> Mansi</a>, 
                            (fiancee then, wife now) whose belief and steady presence has meant the world to me. 

                            A big shoutout to my friends 
                            <a href="https://www.linkedin.com/in/karush-suri-65139a155/" target="_blank">  Karush</a>, 
                            <a href="https://www.linkedin.com/in/ashi-agarwal-899108117/" target="_blank">  Ashi</a>, 
                            <a href="https://www.linkedin.com/in/mahmoud-yassin1/" target="_blank">  Mahmoud</a>, 
                            <a href="https://www.linkedin.com/in/pravallika-katragunta-b12790a1/" target="_blank">  Pravallika</a>, 
                            <a href="https://www.linkedin.com/in/fatemeh-banaeizadeh/" target="_blank">  Fatemeh</a> and others 
                            for the fun times and support, 
                            which made this experience much more enjoyable. And of course a special kudos to 
                            <a href="https://www.linkedin.com/in/marouane-kerbout/" target="_blank">  Marouane</a>,                             
                            for helping me with all the 3D printed parts and rigs required for this work.
                            <br /> <br />

                            Finally, I would like to thank the Department of Systems and Computer Engineering and Carleton University for providing me with this 
                            remarkable opportunity. It truly has been a great experience. 
                            <br /> <br />

                            Cheers, <br />
                            Divyam

                        </p>


                        {/* <h1>
                            Experiment Setup Images  
                        </h1>

                        <h1>
                            Screenshots of the Developed Calibration Tool   
                        </h1> */}

             </div>

        </div>
    )
}


